import React from "react";
import { LoadioStoreSectionListLoaderTemplate } from "themes/administration/loadio/components";

class LoadioStoreSectionListLoader extends React.Component {
    render() {
        return <LoadioStoreSectionListLoaderTemplate {...this.props} />;
    }
}

export default LoadioStoreSectionListLoader;
